import type { WalletBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelTranslationState from "../../lib/panel/panel-translation-state";

export function WalletEmailPanelRenderer(blockProps: WalletBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelBlockAlignment />
      <PanelTranslationState mode="auto" portal />
    </PanelContainer>
  );
}
